export default {
  'return-to-bucket-list': 'Return to bucket list',
  'returns-to-the-input-screen': 'Returns to the input screen',
  'check-cooperation': 'Check cooperation',
  'cooperate': 'Cooperate',
}
